import QuickCard from "./quickCard";
export default QuickCard;